const key = "add-stale-timeout";

const applicable = (resp) => {
	return resp?.config.url.match(/api\/forms\/[0-9]*$/);
};

const modify = (resp) => {
	if(!resp?.data?.Data)
		return;
	
	resp.data.Data.StaleTimeout = "PT2M"; // 2 minutes
};

export const addStaleTimeout = [key, applicable, modify];